import I18n from "shared/i18n"
import moment from "moment"

/**
 * @param {...*} args
 * @returns {moment} A moment instance with the current locale set
 */
function woofMoment(...args) {
  let locale = I18n.locale

  if (locale == "se") locale = "sv"

  moment.locale(locale)

  const momentInstance = moment(...args)

  return momentInstance
}

export default woofMoment
